import { render, staticRenderFns } from "./TrainingContent.vue?vue&type=template&id=76e9212e&scoped=true&"
import script from "./TrainingContent.vue?vue&type=script&lang=js&"
export * from "./TrainingContent.vue?vue&type=script&lang=js&"
import style0 from "./TrainingContent.vue?vue&type=style&index=0&id=76e9212e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9212e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
